import React, { useState } from "react";
import get_preview_url from './utils/get_preview_url';

// const DEVELOPMENT = 'DEVELOPMENT';
// const STAGING = 'STAGING';

const PreviewLinkForm = ({ ITEM_ID, MODEL_TYPE }) => {
  // const [CURRENT_ENVIRONMENT, set_current_environment] = useState(DEVELOPMENT);

  return (
    <form className="container__form" onSubmit={handleSubmit}>
      <button>Go To Preview Link </button>
    </form>
  );

  // function handleChange(e) {
  //   const { id: CURRENT_ENVIRONMENT } = e.target;
  //   set_current_environment(CURRENT_ENVIRONMENT);
  // }

  function handleSubmit(e) {
    e.preventDefault();
    const CURRENT_ENVIRONMENT = 'DEPLOY';

    const PREVIEW_URL = get_preview_url(
      ITEM_ID,
      CURRENT_ENVIRONMENT,
      MODEL_TYPE
    );
    window.open(PREVIEW_URL, "_blank");
  }
};

export default PreviewLinkForm;
